import React from 'react';

import Typography from '../../../../library/typography/typography';

import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import './plp-product-banner-size.scss';

interface PlpProductBannerSizeProps {
  brandName?: string;
  frontSize?: string | null;
  isSizeSearch?: boolean;
  productType: keyof typeof PRODUCT_TYPES;
  rearSize?: string | null;
}

function PlpProductBannerSize(props: PlpProductBannerSizeProps) {
  const {
    brandName,
    frontSize,
    isSizeSearch = false,
    productType,
    rearSize
  } = props;

  return (
    <h1>
      <Typography size="extraSmall" styleName="title" tag="span">
        {isSizeSearch ? 'Browsing' : 'Your'} {brandName && `${brandName} `}
        {productType?.slice(0, -1) || 'Tire'} Size
      </Typography>
      <Typography styleName="size" tag="span" variant="h5">
        {rearSize ? (
          <>
            <div>Front: {frontSize}</div>
            <div>Rear: {rearSize}</div>
          </>
        ) : (
          <>{frontSize}</>
        )}
      </Typography>
    </h1>
  );
}

export default PlpProductBannerSize;
